export default __webpack_public_path__ + "static/media/custom.8452ab66.svg";